import { c as _c } from "react/compiler-runtime";
import { IcoCirclePlay16 } from '@onefootprint/icons';
import { Button } from '@onefootprint/ui';
import useMobileLayout from '@/hooks/use-mobile-layout';
type TestModeButtonProps = {
  label: string;
  onClick: () => void;
};
const TestModeButton = t0 => {
  const $ = _c(7);
  const {
    label,
    onClick
  } = t0;
  const isMobile = useMobileLayout();
  if (isMobile) {
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = <IcoCirclePlay16 />;
      $[0] = t1;
    } else {
      t1 = $[0];
    }
    let t2;
    if ($[1] !== label || $[2] !== onClick) {
      t2 = <Button aria-label={label} onClick={onClick} size="compact" variant="secondary">{t1}</Button>;
      $[1] = label;
      $[2] = onClick;
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    return t2;
  }
  let t1;
  if ($[4] !== label || $[5] !== onClick) {
    t1 = <Button aria-label={label} onClick={onClick} size="compact" variant="secondary" prefixIcon={IcoCirclePlay16}>{label}</Button>;
    $[4] = label;
    $[5] = onClick;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
};
export { TestModeButton };